import WixSDK from 'shared/utils/wix-sdk';
import VIEW_MODES from 'shared/constants/view-modes';

export const isEditorViewMode = () => WixSDK.Utils.getViewMode() === VIEW_MODES.EDITOR;



// WEBPACK FOOTER //
// ./src/shared/selectors/wix-sdk.js